module.exports = __webpack_public_path__ + "static/media/raven_funny_08.0345fb68.svg";